/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { clone } from 'lodash';

// Components
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import CustomForm from 'ui/components/theme/CustomForm.vue';
import SimplifiedColorsForm from 'ui/components/theme/SimplifiedColorsForm.vue';

const __vue_script__ = {
    name: 'MainForm',

    components: {
        BaseSelect,
        CustomForm,
        SimplifiedColorsForm
    },

    props: {
        theme: {
            type: Object,
            required: true
        }
    },

    data() {
        const appearances = [{
            value: 'light',
            label: this.$i18n.t('theme.editor.appearance.light')
        }, {
            value: 'dark',
            label: this.$i18n.t('theme.editor.appearance.dark')
        }, {
            value: 'custom',
            label: this.$i18n.t('theme.editor.appearance.custom')
        }];

        const appearanceObj = appearances.find(a => a.value === (this.theme.appearance || 'custom'));

        return {
            appearanceObj,
            appearances
        };
    },

    computed: {
        appearance() {
            return this.appearanceObj.value;
        }
    },

    methods: {
        setAppearance(data) {
            this.appearanceObj = data;
            this.emit();
        },

        emit(data) {
            if (!data) {
                data = clone(this.theme);
            }

            data.appearance = this.appearance;
            this.$emit('change', data);
        },

        validate() {
            return this.$refs.form.validate();
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "form", staticClass: "main-form", attrs: { tag: "form" } },
    [
      _c("validation-provider", {
        attrs: { rules: "required", slim: true, name: "appearance" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("base-select", {
                  ref: "appearance",
                  attrs: {
                    name: "appearance",
                    "allow-empty": false,
                    errors: errors,
                    label: _vm.$t("theme.editor.appearance.label"),
                    options: _vm.appearances,
                    value: _vm.appearanceObj,
                  },
                  on: { input: _vm.setAppearance },
                }),
              ]
            },
          },
        ]),
      }),
      _vm.appearance === "custom"
        ? _c("custom-form", {
            attrs: { theme: _vm.theme },
            on: { change: _vm.emit },
          })
        : _c("simplified-colors-form", {
            attrs: { theme: _vm.theme, appearance: _vm.appearance },
            on: { change: _vm.emit },
          }),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/theme/MainForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__